'use strict';

const events = require('dom-events');

const showdown = require('showdown');
const converter = new showdown.Converter();

function CommentItem (data) {
  this.tpl = {};
  this.refs = {};
  this.data = data;
  this.html;
}

CommentItem.prototype.buildHTML = function () {
  var html = document.querySelector(this.tpl.comment).cloneNode(true);
  html.setAttribute(
    'data-ref',
    html.getAttribute('data-template') + '-' + this.id
  );
  html.removeAttribute('data-template');

  var avatar = html.querySelector(this.tpl.avatar);
  avatar.setAttribute(
    'data-ref',
    avatar.getAttribute('data-template') + '-' + this.id
  );
  avatar.removeAttribute('data-template');
  avatar.src = this.data.Avatar;

  var datetime = html.querySelector(this.tpl.datetime);
  datetime.setAttribute(
    'data-ref',
    datetime.getAttribute('data-template') + '-' + this.id
  );
  datetime.removeAttribute('data-template');

  var anchor = datetime.firstElementChild;
  anchor.href = this.data.Source + '#' + this.id;

  var time = anchor.firstElementChild;
  time.dateTime = this.date.toISOString();
  time.textContent = this.date.toLocaleString(
    'es-CO',
    {
      timezone: 'America/Bogota',
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  );

  var content = html.querySelector(this.tpl.content);
  content.setAttribute(
    'data-ref',
    content.getAttribute('data-template') + '-' + this.id
  );
  content.removeAttribute('data-template');
  content.innerHTML = converter.makeHtml(this.data.Content);

  if (this.data.hasOwnProperty('Website') && this.data.hasOwnProperty('Author')) {
    html.querySelector(this.tpl.author).remove();

    var authorLink = html.querySelector(this.tpl.authorLink);
    authorLink.setAttribute(
      'data-ref',
      authorLink.getAttribute('data-template') + '-' + this.id
    );
    authorLink.removeAttribute('data-template');
    authorLink.id = this.id;

    var anchor = authorLink.firstElementChild;
    anchor.href = this.data.Website;
    anchor.textContent = this.data.Author;
  }

  if (!this.data.hasOwnProperty('Website') && this.data.hasOwnProperty('Author')) {
    html.querySelector(this.tpl.authorLink).remove();

    var author = html.querySelector(this.tpl.author);
    author.setAttribute(
      'data-ref',
      author.getAttribute('data-template') + '-' + this.id
    );
    author.removeAttribute('data-template');
    author.id = this.id;
    author.textContent = this.data.Author;
  }

  return html;
};

CommentItem.prototype.getHTML = function () {
  if (!this.html) this.html = this.buildHTML();
  return this.html;
};

CommentItem.prototype.onBindEvents = function (event) {};

CommentItem.prototype.bindEvents = function () {
  var comment = this.getHTML();
  this.onBindEvents = this.onBindEvents.bind(this);
  events.on(comment, 'bindEvents', this.onBindEvents);
  events.emit(comment, 'bindEvents');
};

module.exports = CommentItem;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/comment-item.js
// module id = 23
// module chunks = 0